import { FilterPanel } from '../components/FilterPanel';
import { RemovedRidersTable } from '../components/RemovedRidersTable';

export const RemovedRiders = () => {
  return (
    <>
      <FilterPanel />
      <RemovedRidersTable />
    </>
  );
};
